import { AnimatePresence, motion } from 'framer-motion';

interface IClosedStateProps {
	closedMessage?: string | null;
	displayClosedState?: boolean;
}

function ClosedState({ displayClosedState }: IClosedStateProps) {
	return (
		<AnimatePresence onExitComplete={() => null}>
			{displayClosedState && (
				<motion.div
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					exit={{ opacity: 0 }}
					transition={{
						duration: 0.3,
						ease: [0.4, 0, 0.2, 1],
					}}
					className="mt-3 leading-7"
				>
					<p>This form is not accepting submissions right now.</p>
				</motion.div>
			)}
		</AnimatePresence>
	);
}

export default ClosedState;
